export default function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} ERP Watcher</p>
    </footer>
  );
}
